module.exports = __webpack_public_path__ + "static/media/logo.61d398fb.svg";